import { render, staticRenderFns } from "./resultadosExamenProfesional.vue?vue&type=template&id=6f7f942a&scoped=true"
import script from "./resultadosExamenProfesional.vue?vue&type=script&lang=js"
export * from "./resultadosExamenProfesional.vue?vue&type=script&lang=js"
import style0 from "./resultadosExamenProfesional.vue?vue&type=style&index=0&id=6f7f942a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7f942a",
  null
  
)

export default component.exports